import { XMarkIcon } from "@heroicons/react/20/solid"
import { Modals, useModals } from "@/hooks/useModals"
import usePWA from "@/hooks/usePWA"
import PWAModal from "@/modals/PWAModal"
import Button from "./Button"

const PWABanner = () => {
  const { openModal } = useModals()
  const { showBanner, dismissBanner } = usePWA()

  if (!showBanner) return null

  return (
    <>
      <div className="xl:pl-64" role="status" aria-live="polite">
        <div className="flex items-center justify-between gap-2.5 border-y border-gray-200 bg-gray-50 p-4">
          <img
            src="/img/logo-icon.png"
            alt=""
            width={72}
            height={72}
            className="size-9 shrink-0 object-contain"
          />
          <div className="flex-1">
            <div className="text-sm font-semibold text-gray-900">ChessDrop</div>
            <div className="line-clamp-1 text-xs text-gray-500">
              Add to your home screen
            </div>
          </div>
          <div className="flex items-center gap-1.5">
            <Button
              size="sm"
              style="secondary"
              onClick={() => openModal(Modals.PWA)}
            >
              Install
            </Button>
            <Button
              size="sm"
              style="tertiary"
              onClick={dismissBanner}
              staticWidthClassName="w-10"
            >
              <span className="sr-only">Dismiss</span>
              <XMarkIcon className="size-5" />
            </Button>
          </div>
        </div>
      </div>

      <PWAModal />
    </>
  )
}

export default PWABanner
